// extracted by mini-css-extract-plugin
export var collapsedSummary = "_sj-0";